import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { CompetitionApi, CompetitionGridDto } from "../../../../api";
import { ViewButton } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalDataTable } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";

export interface IAnnualCompetitionListProps {
  year: number;
  isCoursing: boolean;
  activityId: number;
}

export const AnnualCompetitionList: React.FunctionComponent<IAnnualCompetitionListProps> = ({
  year,
  isCoursing,
  activityId,
}) => {
  const api = useApiService(CompetitionApi);
  const { t } = useTl();
  const history = useHistory();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: false,
  });

  const { totalCount } = tableState;
  const searchFunction = React.useCallback(() => {
    return api.searchCompetitionByYear(year, isCoursing, activityId);
  }, [activityId, api, isCoursing, year]);

  const { loading, search } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });
  React.useEffect(() => {
    console.log("activity id: ", activityId);
  }, [activityId]);
  React.useEffect(() => {
    search();
  }, [activityId, search]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Action),
        fieldName: "_action",
        computed: true,
        disableSorting: true,
        autoFitContent: true,
        alignment: "center",
        render: (row: CompetitionGridDto) => (
          <ViewButton
            onClick={() => history.push(`${EDrupalRoutes.competition}/${row.competitionId}`)}
            secured={false}
          />
        ),
      },
      {
        header: () => t(ETLCodes.City),
        fieldName: "city",
        computed: true,
        disableSorting: true,
      },
      {
        header: () => t(ETLCodes.SubActivity),
        fieldName: "subActivity",
        render: (row: CompetitionGridDto) => (
          <div>{(!!row.subActivity ? row.subActivity : "") + " " + (!!row.extra ? row.extra : "")}</div>
        ),
      },
      {
        header: () => t(ETLCodes.Club),
        fieldName: "clubName",
      },
      {
        header: () => t(ETLCodes.DateFrom),
        fieldName: "competitionDateFrom",
        computed: true,
        disableSorting: true,
      },
      {
        header: () => t(ETLCodes.DateTo),
        fieldName: "competitionDateTo",
        computed: true,
        disableSorting: true,
      },
    ],
    [history, t]
  );

  return (
    <DrupalFieldSet title={`${year} (${totalCount})`}>
      <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
    </DrupalFieldSet>
  );
};
